import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MdClear as ExitIcon } from 'react-icons/md';
import Modal from '../../shared/modals/modal.component';

import JobsList from './jobsList.component';
import JobErrorDetails from './jobErrorDetails.component';

import { showJobErrorsModal, hideJobErrorsModal } from './store/actions';
import { modalDataSelector } from '../../shared/modals/modals.selectors';
import { ModalNames } from '../../provisionPage/constants';
import Spinner from '../../shared/spinner.component';
import { isFetchingJobs, unreadJobNotificationsSelector } from '../../shared/jim/store/selectors';
import { useMarkJimNotificationsAsSeen } from '../../shared/mutations/jimJobs';
import { JobPropType } from '../../shared/jim/propTypes';

const JobsMenu = ({
  toggleJobsModal,
  jobErrorsModal,
  showJobErrorsModal,
  hideJobErrorsModal,
  isFetching,
  unreadJobNotifications,
  isVisible,
}) => {
  const { show: isErrorsModalVisible, data: jobErrorsModalData } = jobErrorsModal;
  const { mutate: markNotificationsAsSeen } = useMarkJimNotificationsAsSeen();

  useEffect(() => {
    if (isVisible && unreadJobNotifications.length) {
      markNotificationsAsSeen(unreadJobNotifications.map(({ jobId }) => jobId));
    }
  }, [isVisible, markNotificationsAsSeen, unreadJobNotifications]);

  return (
    <>
      <h4 className="popup-header">
        <div className="header">
          <h5>Last Jobs</h5>
          {
            isFetching && <Spinner className="ml-auto d-flex" small />
          }
          <div className="header-icons-container">
            <ExitIcon onClick={toggleJobsModal} className="popup-header-exit"/>
          </div>
        </div>
      </h4>
      <div className="popup-body" id="jobs-tooltip-container">
        <JobsList
          openModal={showJobErrorsModal}
        />
      </div>
      <Modal
        className="job-error-wrapper"
        isVisible={isErrorsModalVisible}
        dismissText="Close"
        closeAction={hideJobErrorsModal}
        title="Error details"
        dismissAction={hideJobErrorsModal}
      >
        <div>
          <JobErrorDetails error={jobErrorsModalData} />
        </div>
      </Modal>
    </>
  );
};

JobsMenu.propTypes = {
  toggleJobsModal: PropTypes.func.isRequired,
  jobErrorsModal: PropTypes.shape({
    show: PropTypes.bool,
    data: PropTypes.string,
  }).isRequired,
  unreadJobNotifications: PropTypes.arrayOf(JobPropType).isRequired,
  showJobErrorsModal: PropTypes.func.isRequired,
  hideJobErrorsModal: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool,
};

export default connect(
  state => ({
    jobErrorsModal: modalDataSelector(state, ModalNames.JobErrors),
    isFetching: isFetchingJobs(state),
    unreadJobNotifications: unreadJobNotificationsSelector(state),
  }),
  {
    showJobErrorsModal,
    hideJobErrorsModal,
  }
)(JobsMenu);
